module.exports = __webpack_public_path__ + "media/images/landings/promotion_4/solution_img_02-6a43ed684b692afcc59bf6b948cda0e6.png";